import React from 'react'
import TwitterShareIcon from '../Icons/TwitterShareIcon'
import LinkedinShareIcon from '../Icons/LinkedinShareIcon'
import FacebookShareIcon from '../Icons/FacebookShareIcon'
import CopyLinkIcon from '../Icons/CopyLinkIcon'
import UtilityLogo from '../../UtilityNav/UtilityLogo'
import Freddie from '../../UtilityNav/Freddie'

const FooterV2 = () => {
    return (
        <div className='footer flex'>
            <div className="flex presented-by">
                <h6>Bloom Season is presented by</h6>
                <a href="https://mailchimp.com">
                <div className="icons">
                    <Freddie/> <UtilityLogo/>
                </div>
                </a>

            </div>

            <div className='links'>
                <TwitterShareIcon/>
                <LinkedinShareIcon/>
                <FacebookShareIcon/>
                <CopyLinkIcon/>
            </div>

            <style jsx>{`
                .footer {
                    padding: 30px 40px;
                    align-items: center;
                    justify-content: space-between;
                }

                .links {
                    display: grid;
                    grid-gap: 6px;
                    grid-template-columns: 1fr 1fr 1fr 1fr;
                }
                .presented-by {
                    align-items: center;
                }
                .presented-by h6 {
                    margin-right: 4px;
                }
                .presented-by :global(svg) {
                    height: 30px;
                    margin-left: 2px;
                }

                h6 {
                    font-weight: 400;
                    font-size: 18px;
                }

                @media (max-width: 769px), (pointer: coarse) {
                    .footer {
                        display: block;
                        padding: 20px;
                    }


                    .presented-by {
                        padding: 20px 0;
                        justify-content: center;
                    }
                    .presented-by h6 {
                        font-size: 15px;
                        white-space: nowrap;
                    }

                    .icons {
                        display: flex;
                    }
                    .footer .icons :global(svg){
                        height: 20px;
                    }

                    .footer .icons :global(.utility-logo) {
                        position: relative;
                        left: -8px;
                    }
                    .links {
                        padding: 20px;
                        padding-bottom: 30px;
                    }
                }
            `}</style>
        </div>
    )
}

export default FooterV2